export type HarvestProofReminderFilterValue =
  | 'september_sent'
  | 'september_not_sent'
  | 'october_sent'
  | 'october_not_sent'
  | 'november_sent'
  | 'november_not_sent';

export const HARVEST_PROOF_REMINDER_FILTER_VALUES = [
  'september_sent',
  'september_not_sent',
  'october_sent',
  'october_not_sent',
  'november_sent',
  'november_not_sent',
] as const satisfies readonly HarvestProofReminderFilterValue[];
